import { ChangeEvent, useState } from "react";

import { getSortOption } from "./getSortOption";
import { SortingInterface, Order } from "./pageHelpers/Common/interface";
import useDebounce from "./useDebounce";

export const useFilters = (
  field: string = "published_at",
  direction: Order = "desc"
) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [sort, setSortOption] = useState<SortingInterface>({
    field: field,
    direction: direction,
  });
  const [filter, setFilterOption] = useState<string>("");

  const debouncedQuery = useDebounce(searchQuery, 400);

  const handleSortChange = (value: string) => {
    const option = getSortOption(value);
    setSortOption(option);
  };

  const handleFilterChange = (value: string) => {
    setFilterOption(value);
  };

  const handleSearchChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const query = target.value;
    query.length === 0 && setSearchQuery("");
    query.length >= 2 && setSearchQuery(query);
  };

  return {
    handleSortChange,
    handleSearchChange,
    handleFilterChange,
    sort,
    filter,
    debouncedQuery,
  };
};
